
import pnpDocsReducer from './pnp-docs/pnp-docs.reducer';
import pnpSettingsReducer from './pnp-settings/pnp-settings.reducer';
import { tabs } from './pnp.tabs';

export default {
    ...tabs,
    ...pnpSettingsReducer,
    ...pnpDocsReducer
};
